export const SuccessMessage = {
	LOGIN_SUCCESSFULLY: 'User logged in successfully.',
	CREATED_SUCCESSFULLY: 'created successfully',
	UPDATED_SUCCESSFULLY: 'updated successfully',
	DELETED_SUCCESSFULLY: 'deleted successfully',
	ALLOCATED_SUCCESSFULLY: 'allocated successfully',
	ASSIGNED_SUCCESSFULLY: 'assigned successfully',
	INVALIDATED_SUCCESSFULLY: 'invalidated successfully',
	GENERATED_SUCCESSFULLY: 'generated successfully',
	BOUGHT_SUCCESSFULLY: 'bought successfully',
	PASSWORD_RESET_SUCCESSFULLY: 'password resets successfully',
	PROFILE_UPLOAD_SUCCESSFULLY: 'profile photo uploaded successfully',
	TEMPORARY_PASSWORD_SUCCESSFULLY_SENT: 'Temporary password has been sent to your email',
	LICENSE_KEY_COPIED: 'License Key Copied',
	LICENSE_KEY_DOWNLOADED: 'License Key successfully downloaded',
	TWOFA_ENABLED: '2FA enabled successfully',
	TWOFA_DISABLED: '2FA disabled successfully',
	TWOFA_RECOVERY_CODE_EMAIL_SENT: '2FA Recovery code successfully sent to your email',
	DATABASE_GENERATED_SUCCESSFULLY: 'database generated successfully',
	SYNC_COMPANY_USERS_SUCESSFULLY_SYNCHED: 'Company users successfully synched',
}

export const ErrorMessage = {
	EXPIRED_LOGGEDIN_SESSION : 'Session Expired. Please Login again',
	USERNAME_REQUIRED: 'Username is required',
	PASSWORD_REQUIRED: 'Password is required',
	CLINIC_REQUIRED: 'Clinic is required',
	DATABASE_REQUIRED: 'Database is required',
	USERAGREE_REQUIRED: 'Kindly accept terms and agreement',
	PASSWORD_AND_CONFIRM_PASSSWORD_NOT_MATCH: 'New/Confirm Password did not match',

	FIELD_REQUIRED: 'Please fill up required fields',

	IS_REQUIRED: ' is required',
	INVALID_DATES: 'Invalid dates',
	INVALID_FILE_FORMAT: 'Invalid file Format, kindly use format given',
	NOT_LATER_THAN_START_DATE: 'End date is not later than Start date',

	URL_NOT_FOUND: 'URL is not found, please go back',
	INCORRECT_DATA_SUBMITTED: 'Incorrect data submitted, please report this issue',
	SERVER_ERROR: 'Server error, please report this issue',
	NO_RESPONSE_SERVER: 'No response from server!',

	PROBLEM_FETCHING_DATA:"There's a problem fetching the data",
	PROBLEM_CREATING_DATA: "There's a problem creating the data",
	PROBLEM_UPDATING_DATA: "There's a problem updating the data",
	PROBLEM_DELETING_DATA: "There's a problem deleting the data",
	PROBLEM_GENERATING_LICENSE: "There's a problem generating the license",
	PROBLEM_BUYING_LICENSE_PACKAGE: "There's a problem buying the license package",
	PROBLEM_BUYING_LICENSE: "There's a problem buying the license",
	PROBLEM_RESETTING_PASSWORD: "There's a problem resetting user password",
	PROBLEM_UPLOADING_PROFILE: "There's a problem uploading user profile photo",
	PROBLEM_ALLOCATING_LICENSE: "There's a problem allocating the license",
	PROBLEM_ASSIGNING_LICENSE: "There's a problem assigning the license",
	PROBLEM_CREATING_OR_CONFIRMING_PAYMENT: "There's a problem creating or confirming payment",
	PROBLEM_SENDING_TEMPORARY_PASSWORD: "There's a problem sending your temporary password",
	PROBLEM_GENERATING_LICENSE_INVOICE: "There's a problem generating the license invoice",
	PROBLEM_GENERATING_DATABASE: "There's a problem generating database",
	PROBLEM_SYNCHING_COMPANY_USERS: "There's a problem synching company users",

	PAGE_NOT_FOUND: 'Page Not Found',
	SOMETHING_WENT_WRONG: 'Something went wrong',
	REFRESH_OR_REPORT: 'Please refresh or report this error',

	CANNOT_PROCEED_ADDING_USER_TIER: 'Cannot proceed adding user tier until the last added tier filled up the max user',
	MAX_USER_CANNOT_BE_LESS_THAN_MIN_USER: 'Max user cannot be less than min users',
	SELECT_ATLEAST_ONE: 'Select atleast 1 ',

	NO_PERMISSON: "You don't have access for this. Contact your Admin to get permission",
	INVALID: 'Invalid',
	ENTER_A_VALID: 'Enter a valid ',
	PROBLEM_TWOFA_ENABLED: 'Error enabling 2FA',
	PROBLEM_TWOFA_DISABLED: 'Error disabling 2FA',
	PROBLEM_TWOFA_RECOVERY_CODE_EMAIL_SENT: 'Error sending 2FA Recovery code to your email',
	NO_LICENSE_KEY_DETECTED: 'No License Found :: Database generation requires a valid license. Please generate or purchase a license to continue',
}